/**
 * Application modules are split into bundles
 * 3 modes provided - bundles.[mode]
 *
 * `all` - one bundle containing all modules
 * `pack` - one or several modules grouped into several bundles (lazy loaded)
 * `lazy` - each module with it's own bundle (lazy loaded)
 *
 */

import bundles from './bundles.pack'
import docs from '@/../docs/pack'

let modules = {}

if (global.config && global.config.namespace === 'docs') {
  // documentation
  modules = docs.pack(eventHandler)
} else {
  // main app modules
  const bundleEnum = Object.keys(bundles)

  bundleEnum.forEach(module => {
    const alias = bundles[module].module && bundles[module].module.alias || bundles[module].alias || module
    const Module = modules[alias] = bundles[module]

    if (module !== 'lazy') {
      modules[alias].on = eventHandler
    }

    if (Module.pack) {
      const packEnum = Object.keys(Module.pack)
      packEnum.forEach(module => {
        const legacy = module[0] !== module[0].toLowerCase()

        if (legacy) {
          Module.pack[module].legacy = true
        }
        modules[module] = Module.pack[module]
        modules[module].on = eventHandler
      })
    }
  })
}

function eventHandler (event, callback) {
  const _module = this.module || this

  switch (event) {
    case 'beforeLoad':
      if (typeof _module === 'function') {
        _module.resolved || callback.call(_module())
      }
      break
    case 'afterLoad':
      if (typeof _module === 'function' && _module().then) {
        _module().then((value) => _module.resolved && callback.call(value))
      }
      break
  }

  return this
}

export default modules



// WEBPACK FOOTER //
// ./src/components/_modules/index.js